module.exports = __webpack_public_path__ + "static/img/betask.1b3939d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/betask.jpeg
// module id = ih9p
// module chunks = 1